export default __webpack_public_path__ + "static/media/point-booster.69a0df7d.svg";